import { PageHeader } from '../layout/PageHeader';
import { ROUTES } from '../../constants/routes';
import { ContentWrapper } from '../layout/styled';
import { Button, useTheme } from '@mui/material';
import { isSmallScreenState } from '../../state/UIState';
import { useAtomValue } from 'jotai';
import { MonthlyNavigation } from '../../components/MonthlyNavigation/MonthlyNavigation';
import { useCallback, useState } from 'react';
import { useIcons } from '../../hooks/useIcons';
import { OpChargeSummaryTable } from './components/OpChargeSummaryTable';
import { opChargeSummaryExcelExport } from './hooks/useOpChargeSummaryExcelExport';
import { useDealOwnerDealsWithTimeLogs } from '../../queries/hooks/useDealOwnerDealsWithTimeLogs';

function DealOwnerOpChargeSummary() {
  const { colors } = useTheme();
  const isSmallScreen = useAtomValue(isSmallScreenState);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const { DownLoadIcon } = useIcons();
  const { data } = useDealOwnerDealsWithTimeLogs(selectedYear, selectedMonth);

  const handleSelectedYear = useCallback((month: number, year: number) => {
    setSelectedMonth(month);
    setSelectedYear(year);
  }, []);

  return (
    <>
      <PageHeader
        title='OP Charge Summary'
        description=''
        breadcrumbs={[
          {
            title: 'All timesheet',
            url: `/${ROUTES.DEAL_OWNER_ALL_TIMESHEETS}`,
            color: colors.textAccent.default,
          },
        ]}
        actionComponent={
          <>
            <MonthlyNavigation
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              handleSelectedMonth={handleSelectedYear}
            />
            <Button
              // disabled={!data || isLoading}
              variant='outlined'
              startIcon={<DownLoadIcon />}
              style={{
                backgroundColor: colors.surfaceBackground.bg1,
                marginBottom: isSmallScreen ? '10px' : '0px',
                marginTop: isSmallScreen ? '8px' : 0,
              }}
              onClick={() => opChargeSummaryExcelExport(data ?? [], selectedYear, selectedMonth)}
            >
              Export
            </Button>
          </>
        }
      />
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <OpChargeSummaryTable selectedYear={selectedYear} selectedMonth={selectedMonth} />
      </ContentWrapper>
    </>
  );
}

export default DealOwnerOpChargeSummary;
